import { cn } from "../dom";
import type { Merge, TupleToUnion } from "type-fest";

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
export interface CSSPropertiesWithVars extends React.CSSProperties {
  [key: `--${string}`]: string;
}
export type Props =
  | (Pick<React.HTMLAttributes<any>, "className"> & {
      style?: CSSPropertiesWithVars | React.CSSProperties;
    })
  | null
  | undefined;

export type MergePropsReturn<T extends Props[]> = Merge<
  TupleToUnion<T>,
  {
    style?: React.CSSProperties;
  }
> & {};

export function mergeProps<T extends Props[]>(
  ...props: T
): MergePropsReturn<T> {
  if (props.length === 1) {
    return props[0] as any;
  }

  return props.reduce<Record<string, any>>((merged, ps: any) => {
    if (!ps) {
      return merged;
    }
    const { className, style, ...rest } = ps;
    const nextMerged = { ...merged, ...rest };

    if (className) {
      nextMerged.className = cn(nextMerged.className, className);
    }
    if (style) {
      nextMerged.style = { ...nextMerged.style, ...style };
    }

    return nextMerged;
  }, {}) as any;
}
